import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, GraduationCap, BookOpen, X } from 'lucide-angular';

export type UserType = 'teacher' | 'student';

@Component({
  selector: 'app-user-type-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './user-type-modal.html',
  styleUrl: './user-type-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserTypeModalComponent {
  readonly selected = output<UserType>();
  readonly closed = output<void>();

  protected readonly icons = {
    GraduationCap,
    BookOpen,
    X,
  };

  protected selectTeacher(): void {
    this.selected.emit('teacher');
  }

  protected selectStudent(): void {
    this.selected.emit('student');
  }

  protected close(): void {
    this.closed.emit();
  }

  protected onBackdropClick(): void {
    this.close();
  }
}
